function stringifyProps(input) {
  return JSON.stringify(input).replace(/'/g, "&#39;")
}

export default stringifyProps
